export function toggleArrayElement<T>(array: T[] | undefined, element: T): T[] {
  if (!array) {
    return [element];
  } else if (array.includes(element)) {
    return array.filter((el) => el !== element);
  } else {
    return [...array, element];
  }
}

export const createIndexArray = (length: number): number[] =>
  Array.from({ length }, (_, index) => index);

export const isLastIndex = (index: number, array: unknown[]): boolean => {
  return index === array.length - 1;
};
